import { AuthContext } from '../../hooks/useAuth'
import { DashboardNavbar } from '../../components/layout/navbar/DashboardNavbar'
import { Navigate, Outlet } from 'react-router-dom'
import { SessionGuard } from '../../components/common/guards/SessionGuard'
import { useContext } from 'react'

export const DashboardLayout = () => {
  const tokenContext = useContext(AuthContext);

  if (tokenContext.isInDashboardRole()) {
    return (
      <>
        <SessionGuard />
        <DashboardNavbar />
        <Outlet />
      </>
    )
  } else {
    return <Navigate to="/" replace />
  }
}